import { MenuItem } from '@material-ui/core';
import React, { useState, useEffect } from 'react';
import { CustomFormikNumberField } from '../../../commons/CustomFormikNumberField';
import { CustomTextField } from '../../../commons/CustomTextField';
import { CustomNumberFieldInputAdornment } from '../../../commons/style/MUI.Styles';
import { TextWrapper, Wrapper } from './PacingForm.Styles';
export var PacingForm = function (_a) {
    var isScheduleExecution = _a.isScheduleExecution, isCampaignConfig = _a.isCampaignConfig, campaignMode = _a.campaignMode, formValues = _a.formValues, oversightMode = _a.oversightMode, errors = _a.errors;
    var _b = useState('Initial Pacing Duration'), initialPacingDurationLabel = _b[0], setInitialPacingDurationLabel = _b[1];
    var _c = useState(null), modeOversight = _c[0], setModeOversight = _c[1];
    useEffect(function () {
        if (formValues.initialCpaMode === 'duration')
            setInitialPacingDurationLabel('Initial Pacing Duration (min)');
        else if (formValues.initialCpaMode === 'samples')
            setInitialPacingDurationLabel('Initial Pacing Sample Size');
        else
            setInitialPacingDurationLabel('Initial Pacing Duration');
    }, [formValues]);
    useEffect(function () {
        setModeOversight(oversightMode);
    }, [oversightMode]);
    return (React.createElement(Wrapper, null,
        React.createElement(TextWrapper, null,
            (isCampaignConfig && campaignMode !== 'agentless') ||
                (isScheduleExecution && oversightMode !== 'agentless') ? (React.createElement(React.Fragment, null,
                React.createElement(CustomFormikNumberField, { name: 'initialCallsPerAgent', label: 'Initial Call per Agent', fullWidth: true }),
                React.createElement(CustomFormikNumberField, { name: 'maxPerAgent', label: 'Max Call per Agent', fullWidth: true }),
                React.createElement(CustomTextField, { name: 'initialCpaMode', label: 'Initial Calls Per Agent Mode', select: true, fullWidth: true },
                    React.createElement(MenuItem, { value: 'none', disabled: true, hidden: true }, "Please Select"),
                    React.createElement(MenuItem, { value: 'duration' }, "Duration"),
                    React.createElement(MenuItem, { value: 'samples' }, "Samples")),
                React.createElement(CustomFormikNumberField, { name: 'initialPacing', label: initialPacingDurationLabel, fullWidth: true, min: 0 }),
                React.createElement(CustomFormikNumberField, { name: 'aBAIncrement', label: 'ABA Increment', fullWidth: true, InputProps: {
                        endAdornment: (React.createElement(CustomNumberFieldInputAdornment, { position: 'end' }, "%"))
                    } }),
                React.createElement(CustomFormikNumberField, { name: 'cPAModifier', label: 'CPA Modifier', fullWidth: true, InputProps: {
                        endAdornment: (React.createElement(CustomNumberFieldInputAdornment, { position: 'end' }, "%"))
                    } }),
                React.createElement(CustomTextField, { name: 'aBACalculation', label: 'ABA Calculation', select: true, fullWidth: true },
                    React.createElement(MenuItem, { value: 'none', disabled: true, hidden: true }, "Please Select"),
                    React.createElement(MenuItem, { value: 'Calls' }, "Calls"),
                    React.createElement(MenuItem, { value: 'Connects' }, "Connects"),
                    React.createElement(MenuItem, { value: 'Detects' }, "Detects")),
                React.createElement(CustomFormikNumberField, { name: 'aBATargetRate', label: 'ABA Target Rate %', fullWidth: true, InputProps: {
                        endAdornment: (React.createElement(CustomNumberFieldInputAdornment, { position: 'end' }, "%"))
                    } }),
                ' ')) : null,
            ((isScheduleExecution === true && oversightMode === 'agentless') ||
                (isCampaignConfig === true && campaignMode === 'agentless')) && (React.createElement(CustomFormikNumberField, { name: 'concurrentCalls', label: 'Max Concurrent Calls', fullWidth: true, min: 1 })),
            isScheduleExecution === true && (React.createElement(CustomFormikNumberField, { name: 'weight', label: 'Campaign Priority', fullWidth: true, min: 1, max: 100 })))));
};
PacingForm.defaultProps = {
// bla: 'test',
};
//# sourceMappingURL=PacingForm.js.map